<div class="container-fluid page" *ngIf="!edit">
  <div class="d-flex page__box p-3 mt-2">&nbsp; Survey
    <div class="export_csv">
      <div class="add_button_text">
        <button class="add_button_new" (click)="formPage()" mat-raised-button color="primary">Conduct a New
          Survey</button>&nbsp;
        <button class="clear_button_export" (click)="openDialogexport()" mat-raised-button
          color="primary">Export</button>
      </div>
    </div>
  </div>
  <div class="page__content shadow p-3 ">
    <div>
      <br />
      <div>
        <table class="firstTable">
          <tr>
            <th class="FirstTh">Total Survey Conducted</th>&nbsp;
            <th class="FirstTh">Total Survey Conducted in this month</th>&nbsp;
            <th class="FirstTh"></th>
          </tr>
          <tr style="height:50px">
            <td class="FirstTd">{{avgData.totalSurvey}}</td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <td class="FirstTd">{{avgData.totalMonthSurvey}}</td>&nbsp;

            <!-- <td class="FirstTd">{{averageReview.totalReview}}</td>
    <td class="FirstTd">{{averageReview.averageReviewRating}}</td> -->
          </tr>
        </table>
      </div>

      <mat-card>
        <div class="example-header" *ngIf="filtershow">
          <mat-form-field class="full-width-field" style="width: 50% !important;">
            <input matInput [(ngModel)]="searchData" (change)="changeFn($event)" placeholder="Search">

          </mat-form-field>&nbsp;
          <button type="submit" (click)="applyFilter(true)" class="btn btn-primary mat-primary search_bar">
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr>


          <!-- 
          <mat-form-field>
            <mat-label>Date Conducted</mat-label>
            <mat-select [(ngModel)]="formdate">
              <mat-option *ngFor="let x of datepicker" [value]="x.viewValue" (click)="getDate(x)">
                {{x.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>&nbsp; -->
          <mat-form-field>
            <!-- <label for="exampleInputEmail1">The range date</label> -->
            <input matInput type="text" name="daterange" placeholder="Date Conducted" [min]="minDate" autocomplete="off"
              [max]="maxDate" [alwaysShowCalendars]="true" ngxDaterangepickerMd [(ngModel)]="sharedate"
               [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}" [showCustomRangeLabel]="true"
              [ranges]="ranges" (change)="onDateRangeChanged(sharedate)" />
          </mat-form-field>&nbsp;

          <mat-form-field>
            <mat-label>Roles</mat-label>
            <mat-select [(ngModel)]="roleName">
              <mat-option *ngFor="let food of rolebased" [value]="food.role">
                {{food.role}}
              </mat-option>
            </mat-select>
          </mat-form-field>&nbsp;


          <mat-form-field style="width: 25%;">
            <mat-label>States</mat-label>
            <mat-select [(ngModel)]="stateName">
              <mat-option *ngFor="let states of targetstateList" [value]="states">
                {{states}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <button type="submit" style="margin-top: 12px; margin-right: -35px;"(click)="clearFilter()"
            class="btn btn-primary mat-primary pull-right">Clear Filter </button>

          <button type="submit" style="margin-top: -60px; margin-right: 83px;" (click)="applyFilter(true)"
            class="btn btn-primary mat-primary pull-right">AppapplyFilterly Filter </button> -->

          <!-- new code -->
          <button class="btn btn-primary mat-primary clear_button pull-right" style="margin-top: 12px;"
            (click)="clearFilter()">
            Clear Filter
          </button> <button type="submit" style="margin-top: 12px; margin-right: 10px;" (click)="applyFilter(true)"
            class="btn btn-primary mat-primary pull-right">
            Apply Filter
          </button>
          <!-- new code end -->

          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip *ngFor="let filter of matChipArray;let i=index" [selectable]="selectable" [removable]="removable"
              (removed)="remove(i,filter.tag)">
              {{filter.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.length == 0"> There's no record found with the given criteria, please
              try again refining your search and filters </p>
          </div>
        </div>
      </mat-card>


      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">

        <mat-table #table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList"> {{SurveyListDataList.date}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList" class="userNameCol">
              {{SurveyListDataList.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="result">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Results </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList" class="userNameCol">
              <span style="width:200px;">{{SurveyListDataList.result}}</span>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="roles">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Roles </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList">
              {{SurveyListDataList.roles}}
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="states">
            <mat-header-cell *matHeaderCellDef mat-sort-header> States </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList">
              {{SurveyListDataList.states}}
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="conductedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Conducted By </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList">
              {{SurveyListDataList.conductedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
            <mat-cell *matCellDef="let SurveyListDataList">


              <div>
                <!--(click)="edit(userlist)"-->
                <mat-icon class="colorchange" (click)="editPage(SurveyListDataList)">edit</mat-icon>&nbsp;
                <mat-icon class="colorchange" (click)="openDialog(SurveyListDataList)">delete</mat-icon>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <div>
          <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
            [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="" class="pagination">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid page" *ngIf="edit">
  <!-- <div class="container-fluid page"> -->
  <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow" (click)="listPage()">&nbsp;
    Edit Survey Updates</div>


  <div class="example-header" style="height: 557px;">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form">
          <div class="fulllwidth">

            <!-- <input type="hidden" formControlName="id" required name="id" value="" /> -->



            <!-- <mat-form-field>
                <mat-select formControlName="surveyname" placeholder="Survey Name" required>
                  <mat-option *ngFor="let opt of SurveyListData" (click)="getSurveyName(opt.surveyName)"
                    [value]="opt.surveyname">
                    {{opt.SurveyName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('surveyname').hasError('required')">
                  Please Select Survey Name.
                </mat-error>
              </mat-form-field>
   
              <mat-form-field>
                <mat-select formControlName="surveyLink" placeholder="Survey Link" required>
                  <mat-option *ngFor="let opt of SurveyListData" (click)="getSurveyLink(opt.surveyLink)"
                    [value]="opt.surveyLink">
                    {{opt.surveyLink}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('surveyLink').hasError('required')">
                  Please Select Survey Link.
                </mat-error>
              </mat-form-field>
  
              <mat-form-field>
                <mat-select formControlName="resultLink" placeholder="Result Link" required>
                  <mat-option *ngFor="let opt of SurveyListData" (click)="getresultLink(opt.resultLink)"
                    [value]="opt.resultLink">
                    {{opt.resultLink}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('resultLink').hasError('required')">
                  Please Select Result Link.
                </mat-error>
              </mat-form-field> -->



            <!-- <mat-form-field>
                <mat-select formControlName="date" placeholder="Date" required>
                  <mat-option *ngFor="let opt of SurveyListData" (click)="getDate(opt,null)"
                    [value]="opt.date">
                    {{opt.date}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('date').hasError('required')">
                  Please Select date.
                </mat-error>
              </mat-form-field> -->

            <!-- <mat-form-field>
                <mat-select formControlName="surveyDate" placeholder="Survey Date" required>
                  <mat-option *ngFor="let opt of SurveyListData" (click)="getsurveyDate(opt.surveyDate)"
                    [value]="opt.surveyDate">
                    {{opt.surveyDate}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('surveyDate').hasError('required')">
                  Please Select Survey Date.
                </mat-error>
              </mat-form-field> -->

            <input type="hidden" formControlName="surveyID" value="" />

            <mat-form-field>
              <input type="text" formControlName="surveyName" placeholder="Survey Name" matInput>
            </mat-form-field>

            <mat-form-field>
              <input type="text" formControlName="attachLink" placeholder="Survey Link" matInput>
            </mat-form-field>


            <mat-form-field>
              <input type="text" formControlName="resultLink" placeholder="Result Link" matInput>
            </mat-form-field>



            <mat-form-field style="width: 48% !important;">
              <mat-label>Roles</mat-label>
              <mat-select formControlName="role" multiple>
                <mat-option *ngFor="let food of rolebased" [value]="food.role">
                  {{food.role}}
                </mat-option>
              </mat-select>
            </mat-form-field>&nbsp;

            <mat-form-field style="width: 48% !important;">
              <mat-label>States</mat-label>
              <mat-select formControlName="states" multiple>
                <mat-option *ngFor="let states of targetstateList" [value]="states">
                  {{states}}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <!-- <mat-form-field>
              <input type="text" formControlName="remark" placeholder="Remark" matInput>
            </mat-form-field>
            -->

            <div *ngIf="requirederror">Please Enter Mandatory Fields</div>

            <div class="row">
              <div class="col-md-10">
              </div>
              <div class="col-md-2">

                <button mat-button type="submit" (click)="onSubmit()" [disable]="disable"
                  class="submitBtn">Send</button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>

    </mat-card>

  </div>
  <!-- </div> -->
</div>